let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jhTnu")).then(() => parcelRequire('1FRaK'));